var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#9DE49B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_211_6737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_211_6737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2266 38.3825C22.0755 38.2314 22 38.041 22 37.8111C22 37.5813 22.0755 37.392 22.2266 37.2433L24.0937 35.3762C23.5119 34.6657 23.0584 33.8693 22.7332 32.9871C22.408 32.105 22.2455 31.1698 22.2455 30.1818C22.2455 27.8977 23.0381 25.963 24.6233 24.3778C26.2085 22.7926 28.1432 22 30.4272 22H36.9517C37.4119 22 37.8031 22.1612 38.1255 22.4835C38.4478 22.8059 38.609 23.1972 38.609 23.6573V30.1818C38.609 32.4659 37.8164 34.4005 36.2312 35.9857C34.646 37.5709 32.7113 38.3636 30.4272 38.3636C29.4394 38.3636 28.5089 38.201 27.6357 37.8758C26.7625 37.5506 25.9706 37.0971 25.2601 36.5153L23.3657 38.3825C23.217 38.5335 23.0277 38.609 22.7979 38.609C22.568 38.609 22.3776 38.5335 22.2266 38.3825ZM26.6552 33.9521C26.8063 34.1267 26.9963 34.2106 27.2253 34.2039C27.4542 34.1972 27.6495 34.1139 27.8111 33.9538L32.093 29.6825C32.2622 29.5132 32.3468 29.3188 32.3468 29.0993C32.3468 28.8797 32.2633 28.6864 32.0961 28.5192C31.943 28.3661 31.7515 28.2895 31.5216 28.2895C31.2918 28.2895 31.1026 28.365 30.9538 28.5161L26.6552 32.8146C26.5042 32.964 26.4287 33.1506 26.4287 33.3745C26.4287 33.5985 26.5042 33.791 26.6552 33.9521Z",
    fill: "#1EB65B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDefaultImage);
export default __webpack_public_path__ + "static/media/profile-default-image.8db585db2ceee3d1f99374befc13534b.svg";
export { ForwardRef as ReactComponent };